import Vue from "vue";

Vue.mixin({
    data() {
        return {
            uuid: '_' + Math.random().toString(36).substr(2, 9),
        }
    },
    computed: {
        isAuthenticated() {
            return this.$auth.ready() && this.$auth.check();
        },
    },
    methods: {
        savedToast() {
            this.successToast(this.$t('Saved'));
        },

        successToast(message, title = this.$t('Success')) {
            this.$root.$bvToast.toast(message, {
                title,
                solid: true,
                variant: 'success',
            });
        },


        fullUrl(url) {
            return window.location.origin + url
        },

        forbiddenToast(message, title = this.$t('Forbidden')) {
            this.$root.$bvToast.toast(message, {
                title,
                solid: true,
                variant: 'danger',
            });
        },


        focusRef(ref) {
            // Some references may be a component, functional component, or plain element
            // This handles that check before focusing, assuming a `focus()` method exists
            // We do this in a double `$nextTick()` to ensure components have
            // updated & popover positioned first
            this.$nextTick(() => {
                this.$nextTick(() => {
                    (ref.$el || ref).focus();
                });
            });
        },
    }
});
